import {
  U21Button,
  U21Chip,
  U21Divider,
  U21Modal,
  U21Spacer,
  U21Typography,
} from 'app/shared/u21-ui/components';

import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { AlertHitResponse } from 'app/modules/alerts/types/responses';
import { formatDatetime } from 'app/shared/utils/date';
import { CompositeQueryTreeNode } from 'app/modules/rulesAdvanced/models';
import { ROUTES_MAP } from 'app/shared/utils/routes';
import {
  TAB_HASHES,
  TAB_PATHS,
} from 'app/modules/alerts/components/AlertDetails/Tabs/constants';
import { ConditionBreakdown } from 'app/modules/detectionModels/components/ConditionBreakdown/ConditionBreakdown';

export interface ConditionBreakdownProps {
  ruleCondition: CompositeQueryTreeNode | null;
  open: boolean;
  close: () => void;
  alertId: number;
  ruleTitle: string | undefined;
  alertHits: AlertHitResponse[];
  alertHitIndex: number;
  totalAlertHitIndex: number;
  onHeaderAction: (n: number) => void;
  loading?: boolean;
}

export const ConditionBreakdownModal = ({
  ruleCondition,
  open,
  close,
  alertId,
  ruleTitle,
  alertHits,
  alertHitIndex,
  totalAlertHitIndex,
  onHeaderAction,
  loading = false,
}: ConditionBreakdownProps) => {
  if (alertHitIndex < 0) {
    return null;
  }
  const createdAt = alertHits[alertHitIndex]?.created_at || '';

  return (
    <U21Modal
      open={open}
      size="large"
      onClose={() => close()}
      title="Why Did This Flag?"
      loading={loading}
      headerAction={
        <U21Spacer horizontal>
          <div>
            Updates {alertHitIndex + 1} of {totalAlertHitIndex}
          </div>
          <U21Button
            onClick={() => onHeaderAction(alertHitIndex - 1)}
            disabled={alertHitIndex === 0}
          >
            <ChevronLeft />
          </U21Button>
          <U21Button
            onClick={() => onHeaderAction(alertHitIndex + 1)}
            disabled={alertHitIndex === totalAlertHitIndex - 1}
          >
            <ChevronRight />
          </U21Button>
          <U21Divider flexItem />
        </U21Spacer>
      }
      actionButtonProps={{
        children: 'View All Updates',
        to: {
          pathname: `${ROUTES_MAP.alertsId.path.replace(':id', String(alertId))}/${TAB_PATHS.ALERT_UPDATES}`,
          hash: TAB_HASHES.ALERT_UPDATES,
        },
      }}
      onAction={() => {
        close();
      }}
    >
      <U21Spacer spacing={2}>
        <div>
          <U21Typography variant="body1" component="div">
            <U21Chip>Alert #{alertId}</U21Chip> was{' '}
            {alertHitIndex === totalAlertHitIndex - 1 ? 'flagged' : 'updated'}{' '}
            by <U21Chip>{ruleTitle}</U21Chip> on {formatDatetime(createdAt)}.
          </U21Typography>
        </div>

        <ConditionBreakdown
          ruleCondition={ruleCondition}
          open={open}
          close={close}
          alertId={alertId}
          ruleTitle={ruleTitle}
          alertHits={alertHits}
          alertHitIndex={alertHitIndex}
          totalAlertHitIndex={totalAlertHitIndex}
          onHeaderAction={onHeaderAction}
        />
      </U21Spacer>
    </U21Modal>
  );
};
